import { BaseClient } from 'src/common-services/clients/base-client'
import {
  ApproveUserSignUpRequestRequest,
  CreateUserSignUpRequestRequest,
  DeclineUserSignUpRequestRequest,
  UserSignUpRequest,
} from 'src/common-services/types/signup-request-types'

export class SignUpRequestClient extends BaseClient {
  getPendingUserSignUpRequests(): Promise<UserSignUpRequest[]> {
    return this.call<UserSignUpRequest[]>('/sign-up-request', 'GET')
  }

  createUserSignUpRequest(request: CreateUserSignUpRequestRequest): Promise<void> {
    return this.call('/sign-up-request', 'POST', { data: request })
  }

  approveUserSignUpRequest(request: ApproveUserSignUpRequestRequest): Promise<void> {
    return this.call('/sign-up-request/approve', 'POST', { data: request })
  }

  declineUserSignUpRequest(request: DeclineUserSignUpRequestRequest): Promise<void> {
    return this.call('/sign-up-request/decline', 'POST', { data: request })
  }
}
